import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import Slider from '../../../../components/Content/Slider';
import ProductListItem from './ProductListItem';

function ProductSlider({ products, countPerSlide = 3, renderItem = null, hideAddToCart = false, trackSelection = false, listId = '' }) {
	const groups = [];
	const itemsTemp = [...products];
	while(itemsTemp.length > 0) {
		groups.push(itemsTemp.splice(0, countPerSlide));
	}

	const colSize = 12 / countPerSlide;
	const slides = groups.map((contents, index) => {
		return (
			<Row key={index} className="gx-1">
				{contents.map((item, index) => (
					<Col key={item._id || index} xs={colSize} xl={colSize} className="mb-3">
						{renderItem ? renderItem(item) : <ProductListItem product={item} viewType="mini" hideAddToCart={hideAddToCart} trackSelection={trackSelection} listId={listId} />}
					</Col>
				))}
			</Row>
		);
	});

	return (
		<Slider
			slides={slides.map(content => ({ content }))}
			disableLightbox
			disableControls={slides.length < 2}
			disableIndicators /* ={slides.length < 2} */
			interval={8000}
		/>
	);
}

ProductSlider.propTypes = {
	products: PropTypes.arrayOf(PropTypes.object).isRequired,
	countPerSlide: PropTypes.number,
	renderItem: PropTypes.func,
	listId: PropTypes.string,
	trackSelection: PropTypes.bool,
	hideAddToCart: PropTypes.bool,
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(ProductSlider);
